<template>
  <div class="msgHistory-box">
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px">
          <div class="clearfix top-info">
            <span style="vertical-align: middle">类型：{{msgType}}</span>
            <span style="margin-left: 30px;vertical-align: middle">合同：{{contractBillName || '无'}}</span>
              <!-- <el-button size="mini" @click="appendMsg" type="primary" class="append-btn">消息补充</el-button> -->
          </div>
          <el-timeline>
              <el-timeline-item :timestamp="item.sendDate" placement="top" v-for="(item, i) in msgHistroy" :key="i" :class="{active: item.comeFrom == 0}">
                  <div>
                      <!-- <div style="font-size: 15px;">
                          {{item.title}}
                          <span class="reply-btn" v-if="item.canReply == '1'" @click="replyMsg(item)">回复</span>
                      </div>
                      <div style="font-size: 12px;"> -->
                          <span class="send-person">发件人：{{item.sendBy}}</span>
                          <p style="color: #333333;">{{item.content}}</p>
                          <!-- <span v-if="i == msgHistroy.length - 1" style="margin-left: 10px;">消息类型: {{item.messageType}}</span> -->
                          <span v-if="item.baseFiles && item.baseFiles.length > 0">附件：
                            <span v-for="file in item.baseFiles" :key="file.id">
                                <a class="vlink" v-if="file.id" :href="downManagerApi +'?path='+file.filePath+'&name='+file.fileName" :download="file.fileName">
                                    {{file.fileOldName?file.fileOldName:file.fileName}}
                                </a>
                                <span v-else>{{file.fileOldName?file.fileOldName:file.fileName}}</span>
                            </span>
                          </span>
                      </div>
                      <!-- <p>{{item.content}}</p>
                  </div> -->
              </el-timeline-item>
          </el-timeline>
          <div slot="footer" class="dialog-footer">
              <el-button @click="cancel">关 闭</el-button>
              <el-button class="reply-btn" @click="replyMsg()">回复</el-button>
          </div>
      </el-dialog>
      <informationForm ref="infoForm" @refresh="refresh"></informationForm>
  </div>
</template>

<script>
    import util from '@/util'
    import informationForm from './informationForm';
    export default {
        name: 'msgHistory',
        components: {informationForm},
        data() {
            return {
                msgId: '',
                isRec: '',
                dialogVisible: false,
                msgHistroy: [],
                downManagerApi: `${util.baseUrl}rest/api/sftp/download`,
                dialogTitle:'',
                contractBillName: '',
                msgType: ''
            }
        },
        created() {

        },
        methods: {
            appendMsg () {
                this.$refs['infoForm'].showMessageDialog(true);
            },
            replyMsg () {
                let item = this.msgHistroy[this.msgHistroy.length - 1]
                this.$refs['infoForm'].showMessageReply(item);
            },
            cancel () {
                this.dialogVisible = false;
            },
            refresh(){
                this.$http.post('rest/api/msg/getSupplierBaseMessageHistory', { msgId: this.msgId, stockId: this.$root.stockId, isRec: this.isRec }).then((res) => {
                    if (res.data.result) {
                        this.msgHistroy = res.data.value || [];
                        if(this.msgHistroy.length) {
                          this.msgType = this.msgHistroy[this.msgHistroy.length - 1].messageType
                          this.contractBillName = this.msgHistroy[this.msgHistroy.length - 1].contractBillName
                          this.dialogTitle = this.msgHistroy[this.msgHistroy.length - 1].title
                        }
                    } else {
                        this.$alert(res.data.message);
                    }
                });
            },
            show (msgId, isRec) {
                this.msgId = msgId;
                this.isRec = isRec;
                this.dialogVisible = true;
                this.$http.post('rest/api/msg/getSupplierBaseMessageHistory', { msgId: msgId, stockId: this.$root.stockId, isRec: isRec }).then((res) => {
                    if (res.data.result) {
                        this.msgHistroy = res.data.value || [];
                        if(this.msgHistroy.length) {
                            this.msgType = this.msgHistroy[this.msgHistroy.length - 1].messageType
                            this.contractBillName = this.msgHistroy[this.msgHistroy.length - 1].contractBillName
                            this.dialogTitle = this.msgHistroy[this.msgHistroy.length - 1].title
                        }
                    } else {
                        this.$alert(res.data.message);
                    }
                });
            }
        }
    }
</script>

<style lang="postcss">
    .msgHistory-box .clearfix:after {
        display: table;
        content: " ";
        clear: both;
    }

    .reply-btn {
        color: white;
        font-size: 12px;
        background-color: #f39436;
        line-height: 20px;
        padding: 8px 22px;
        border-radius: 5px;
        letter-spacing: 3px;
        cursor: pointer;
    }

    .append-btn {
        float: right;
    }
    .msgHistory-box .vlink {
        color: var(--cTxt2);
    }
    .top-info{
        margin: 0 -20px 20px;
        border-bottom: 3px solid #E4E7ED;
        padding: 0 20px 10px;
    }
    .msgHistory-box .el-timeline-item__wrapper{
        position: relative;
        padding-left: 0;
        margin-left: 28px;
    }
    .msgHistory-box .el-timeline-item__timestamp{
        padding-left: 200px;
    }
    .msgHistory-box .el-timeline-item__timestamp.is-top{
        padding-bottom: 8px;
        margin-bottom: 0;
        padding-left: 350px;
    }
    .msgHistory-box .active .el-timeline-item__wrapper{
        background: #E1FBFB;
    }
    .send-person{
        position: absolute;
        top: 0;
    }
    .msgHistory-box .el-dialog__wrapper .el-dialog__body p {
        margin-left: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/msgex/comps/msgHistory.vue